<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">
          <span>外聘教师日程</span>
          <!-- <button type="button" class="btn btn-default btn_option"
                   style="height: 25px;line-height: 10px;float: right;margin-top: 5px;"
                   @click="exportClassStatistics()">导出</button>-->
        </div>
        <div class="searcharea">
          <label>时间筛选:</label>
          <input type="text" class="form-control" name="chooseStartDate" id="chooseStartDate" style="width: 120px;display: inline-block" v-model="teacherInfo.startDate" readonly>
          —
          <input type="text" class="form-control" name="chooseEndDate" id="chooseEndDate" style="width: 120px;display: inline-block" v-model="teacherInfo.endDate" readonly>
          <input class="form-control" placeholder="请输入主讲教师或课程名称" style="width: 200px;display: inline-block" v-model="searchParams.name"/>
          <button type="button" class="btn btn-default btn_option" style="" @click="searchTeacherList()">查询</button>
          <!--<button type="button" class="btn btn-default btn_option" style="height: 28px;line-height: 15px" @click="searchTeacherList()">确定</button>-->

        </div>
      </div>
      <div class="body_content class_body_content" id="externalTeacher_div">



        <div class="classStatisticsList_div">
          <table class="table table-striped table-bordered table_classStatistics">
            <thead>
            <tr>
              <!--<th width="5%"><input type="checkbox" @click="checkAll"></th>-->
              <th width="5%">序号</th>
              <th width="10%">主讲教师</th>
              <th width="20%">课程名称</th>
              <th width="20%">上课时间</th>
              <th width="10%">上课地点</th>
              <th width="20%">班级名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(teaOne, index) in externalTeacherList" :key="index">
              <!-- <td width="5%">
                 <input name="list_item" type="checkbox" :checked="checkbox.checkIds.indexOf(teaOne.teacherId)>=0" @click="checkedOne(teaOne.teacherId)">
               </td>-->
              <td width="5%">{{index+1}}</td>
              <td width="10%">{{teaOne.teacherName}}</td>
              <td width="20%">{{teaOne.name}}</td>
              <td width="20%">{{teaOne.startDate}}  &nbsp;&nbsp;&nbsp;&nbsp;{{teaOne.time}}</td>
              <td width="20%">{{teaOne.roomName}}</td>
              <td>{{teaOne.clazzName}}</td>
              <!-- <td width="10%">
                 <div class="details_pic" data-toggle="modal" data-target="#myModal" @click="initCourseDetailsList(teaOne.teacherId,teaOne.teacherName)"></div>
               </td>-->
            </tr>
            </tbody>
          </table>
          <!--分页-->
          <page-view v-bind="searchParams"></page-view>
          <!--<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog dialog-work">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">{{teacherInfo.teacherName}}</h4>
                </div>
                <div class="modal-body modal_work_details">
                  <table class="table table-bordered table-striped table_details">
                    <thead>
                    <tr>
                      <th width="40%">班级</th>
                      <th width="20%">班级日期</th>
                      <th width="20%">课时</th>
                      <th width="20%">课数</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(courseDetailsOne, index) in courseDetailsList" :key="index">
                      <td width="40%">{{courseDetailsOne.clazzName}}</td>
                      <td width="20%">{{courseDetailsOne.startDate}}—{{courseDetailsOne.endDate}}</td>
                      <td width="20%">{{courseDetailsOne.takeHours}}</td>
                      <td width="20%">{{courseDetailsOne.counts}}</td>
                    </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>-->
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';
  import WorkloadStatistics from '../components/workloadStatistics';
  import pageView from '../components/pageView';


  export default {
    name: "externalTeacherStatistics",
    components:{pageView},
    data() {
      return {
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        //今日日期
        timeDate: '',

        //外聘教师集合
        externalTeacherList:[],

        //单个教师课时详情集合
        courseDetailsList:[],

        teacherInfo:{
          teacherId:'',
          teacherName:'',
          startDate:'',
          endDate:'',
        },


        checkbox: {
          checkIds: [],
        },

        /*分页*/
        searchParams: {
          name:'',
          all: 0,
          rows: 10,
          page:1
        },

        token: this.$store.state.access_token,
        hrefExport:this.$store.state.serviceBase+"resources/",
      }
    },
    /*components:{
      WorkloadStatistics
    },*/
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //日期
        this_.dateDefault();
        this_.initData();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initData;
      });
    },
    methods: {
      /**
       * 外聘教师统计列表
       */
      initData(pageParams){
        let this_ = this;
        this_.searchParams = Object.assign(this_.searchParams, pageParams);
        schoolAxios({
          method: 'get',
          url: 'lesson/findPageByExternalTeacher',
          params: {
            startDate:this_.teacherInfo.startDate,
            endDate:this_.teacherInfo.endDate,
            page:this_.searchParams.page,
            rows:this_.searchParams.rows,
            name:this_.searchParams.name,
          }
        }).then(function (resp) {
          if (resp.data.success) {
            this_.externalTeacherList = resp.data.list;
            this_.searchParams.all = resp.data.totalPage;
          }
        });
      },
      /**
       * 搜索班级
       */
      searchTeacherList(){
        this.searchParams.page = 1;
        this.initData();
      },

      /**
       * 详情
       */
      initCourseDetailsList(teacherId,teacherName){
        let this_=this;
        if(this_.userCode.indexOf(this_.leaderUserCode) != -1) {
          schoolAxios({
            method: 'get',
            url: 'teacherLesson/takeHoursDetailsAllList',
            params: {
              "teacherId": teacherId,
              "startDate":this_.teacherInfo.startDate,
              "endDate":this_.teacherInfo.endDate
            }
          }).then(function (response) {
            // console.info(response);
            let data = response.data;
            if (data.success) {
              this_.teacherInfo.teacherId = teacherId;
              this_.teacherInfo.teacherName = teacherName;
              this_.courseDetailsList = data.list;
            }
          });
        }else {
          schoolAxios({
            method: 'get',
            url: 'teacherLesson/takeHoursDetailsList',
            params: {
              "teacherId": teacherId,
              "startDate":this_.teacherInfo.startDate,
              "endDate":this_.teacherInfo.endDate
            }
          }).then(function (response) {
            // console.info(response);
            let data = response.data;
            if (data.success) {
              this_.teacherInfo.teacherId = teacherId;
              this_.teacherInfo.teacherName = teacherName;
              this_.courseDetailsList = data.list;
            }
          });
        }
      },

      /**
       * 初始化日期选择框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#chooseStartDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseStartDate").val();
          this_.teacherInfo.startDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#chooseEndDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#chooseEndDate").val();
          this_.teacherInfo.endDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });
      },

      checkedOne (teacherId) {
        let this_ = this;
        let idIndex = this_.checkbox.checkIds.indexOf(teacherId);
        if (idIndex >= 0) {//如果已经包含就去除
          this_.checkbox.checkIds.splice(idIndex, 1);
        } else {//如果没有包含就添加
          this_.checkbox.checkIds.push(teacherId);
        }
      },
      /*全选*/
      checkAll: function (e) {
        let this_ = this;
        let checked = e.target.checked;
        if(checked){
          this_.checkbox.checkIds=[];
          let externalTeacherList = this_.externalTeacherList;
          for(let i=0;i<externalTeacherList.length;i++){
            let idIndex = this_.checkbox.checkIds.indexOf(externalTeacherList[i].teacherId);
            if (idIndex < 0) {//如果没有包含就添加
              this_.checkbox.checkIds.push(externalTeacherList[i].teacherId);
            }
          }
        }else{
          this_.checkbox.checkIds=[];
        }
        let element = document.querySelectorAll("input[name=list_item]");
        element.forEach((item) => {
          item.checked = checked;
        });
      },

      /**
       * 导出
       */
      exportClassStatistics(){
        let this_=this;
        let teacherIds =this_.checkbox.checkIds.toString();
        schoolAxios({
          method: 'get',
          url:'teacherLesson/takeHoursExcel',
          params: {
            "teacherIds":this_.checkbox.checkIds.toString(),
            "access_token":this_.token
          }
        }).then(function (response) {
          if(teacherIds){
            location.href=this_.hrefExport+response.data.data;
          }else {
            "请勾选导出数据".showMessage();
          }
        });
        /* if(teacherIds){
           location.href= this_.hrefExport+'?teacherIds='+this_.checkbox.checkIds.toString()+'&access_token='+this_.token;
         }else {
           "请勾选导出数据".showMessage();
         }*/

      },
      clearCookie() {
        let keys = document.cookie.match(/[^ =;]+(?=\=)/g);
        console.info(keys);
        if (keys) {
          for (let i = keys.length; i--;) {
            document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
            document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
            document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
          }
        }
        console.info(document.cookie);
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  /*@import "../assets/css/classStatistics.css";*/

  .table_classStatistics {
    margin: 15px 0 0 0;
  }
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .details_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/workLoad/details_mouseOver.png");
    background-size: 100% 100%;
    margin: 0 0 0 45%;
  }
  .form-group-div {
    margin-top: 10px;
  }
  .form-group label {
    width: 100px;
  }
  .modal-content.modal-work-content {
    width: 900px;
  }
  /*表头固定*/
  .table_details tbody{
  }

  .table_classStatistics tbody{
  }
  .searcharea{
    position: absolute;
    right: 0;
  }
</style>
<style>
  #externalTeacher_div #page-break {
  }
</style>



// WEBPACK FOOTER //
// src/components/externalTeacherStatistics.vue